import { render, staticRenderFns } from "./DeleteEnrolmentModal.vue?vue&type=template&id=54104890&"
import script from "./DeleteEnrolmentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteEnrolmentModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteEnrolmentModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports